import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Radio,
  Checkbox,
  Modal,
  Table,
  File
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";

import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "universal-cookie";
import '../../../style/director-style.css'

const cookies = new Cookies();

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let attributeName,
  attributeValue,
  attributeValueArray = [],
  attributeDateArray = [],
  updateDataValueArray = [];
let attributeData = [],
  newMatrix,
  skuCode = [],
  quantity = [],
  title = [],
  createdMatrix = [],
  indexData = [],
  newArray = [],
  currentIndex = "";
class Attributes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: this.props.indexKey,
      date: new Date(),
      attributeData: !isEmpty(this.props.postAttributes)
        ? this.props.postAttributes
        : [],
      attributeStatus: false,
      chooseType: true,
      type: "menu",
      attributeValueArray: "",
      attributeDateArray: "",
      updateData: false,
      lgShow: false,
      edittype: "",
      quantity: "",
      skuCode: "",
      attributeFile:"",
      currentIndex
    };
  }

  AttributeStatus = () => {
    this.setState({ attributeStatus: true, edittype: "" });
    if (this.state.indexKey != this.props.indexKey) {
      this.clearAttribute();
    }
  };

  AttributeFile = () => {
    this.setState({ attributeFile: true, edittype: "" });
    if (this.state.indexKey != this.props.indexKey) {
      this.clearAttribute();
    }
  };

  cancelAttriute = () => {
    this.clearAttribute();
    this.setState({ attributeStatus: false, attributeFile:false });
  };

  handleType = e => {
    if (e.target.value == "menu") {
      this.setState({ chooseType: true, type: e.target.value });
    } else {
      this.setState({ chooseType: false, type: e.target.value });
    }
  };

  startDateTime = date => this.setState({ 
    startDateTime: date 
  });
  endDateTime = date => this.setState({ 
    endDateTime: date
  });

  componentDidMount() {  
  }

  componentWillMount() {
    this.clearAttribute();
    attributeData = [];  
    
    if (!isEmpty(this.props.postMatrix)) {
      let postMatrix = this.props.postMatrix;
      for (var i = 1, k = 0; i <= postMatrix.length; i++) {
        if (!Array.isArray(skuCode[this.props.indexKey])) {
          skuCode[this.props.indexKey] = [];
        }
        if (!Array.isArray(skuCode[this.props.indexKey][i])) {
          skuCode[this.props.indexKey][i] = [];
        }

        if (!Array.isArray(quantity[this.props.indexKey])) {
          quantity[this.props.indexKey] = [];
        }

        if (!Array.isArray(quantity[this.props.indexKey][i])) {
          quantity[this.props.indexKey][i] = [];
        }
        skuCode[this.props.indexKey][i] = postMatrix[k].skuCode;
        quantity[this.props.indexKey][i] = postMatrix[k].quantity;
        this.props.matrixData(postMatrix, this.state.indexKey);
        k++;
      }
    } else {
      skuCode=[];
      quantity=[]; 
    }

    if (isEmpty(this.props.postAttributes)) {
      if (!isEmpty(attributeData)) {
        this.setState({ attributeData: attributeData });
      }
    } else { 
      attributeData = this.props.postAttributes;
      this.setState({
        attributeData: this.props.postAttributes,
        indexKey: this.props.indexKey
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clearStatus) {
      this.state.attributeData = "";
      attributeData = [];
    }

    if (isEmpty(this.props.postAttributes)) {
      if (!isEmpty(attributeData)) {
        this.setState({ attributeData: attributeData });
      }
    } else { 
      attributeData = this.props.postAttributes;
      this.setState({
        attributeData: this.props.postAttributes,
        indexKey: this.props.indexKey
      });
    }
    
    if (!isEmpty(this.props.postMatrix)) {
      let postMatrix = this.props.postMatrix;
      for (var i = 1, k = 0; i <= postMatrix.length; i++) {
        if (!Array.isArray(skuCode[this.props.indexKey])) {
          skuCode[this.props.indexKey] = [];
        }
        if (!Array.isArray(skuCode[this.props.indexKey][i])) {
          skuCode[this.props.indexKey][i] = [];
        }

        if (!Array.isArray(quantity[this.props.indexKey])) {
          quantity[this.props.indexKey] = [];
        }

        if (!Array.isArray(quantity[this.props.indexKey][i])) {
          quantity[this.props.indexKey][i] = [];
        }
        skuCode[this.props.indexKey][i] = postMatrix[k].skuCode;
        quantity[this.props.indexKey][i] = postMatrix[k].quantity;
        this.props.matrixData(postMatrix, this.state.indexKey);
        k++;
      }
    }
  }

  clearAttribute() {
    attributeName = "";
    attributeValueArray = [];
    attributeDateArray = [];
    updateDataValueArray = [];
    this.setState({
      attributeValueArray: "",
      attributeDateArray: "",
      attributeStatus: false,
      updateData: false
    });
  }

  clearUpdateAttribute() {
    attributeName = "";
    attributeValueArray = [];
    attributeDateArray = [];
    updateDataValueArray = [];
    this.setState({
      attributeStatus: false,
      updateData: false
    });
  }

  saveAttriute = e => {
    e.preventDefault();
    if (
      isEmpty(this.state.attributeValueArray) &&
      isEmpty(this.state.attributeDateArray)
    ) {
      alert("Please add attribute.");
      return false;
    }
    attributeData = (this.state.attributeData && this.state.attributeData !== 'null') ? this.state.attributeData : attributeData;
    if (isEmpty(cookies.get("indexKey"))) {
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("indexKey", this.props.indexKey, { path: "/", expires: d });
    }

    if (cookies.get("indexKey") != this.props.indexKey) {
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("indexKey", this.props.indexKey, { path: "/", expires: d });
      if (this.state.attributeData) {
        attributeData = (this.state.attributeData && this.state.attributeData !== 'null') ? this.state.attributeData : [];
      } else {
        attributeData = [];
      }
    }
    let attrData = {
      name: attributeName,
      dataValue:
        this.state.type == "menu"
          ? this.state.attributeValueArray
          : this.state.attributeDateArray,
      type: this.state.type
    };

    attributeData.push(attrData);
    this.setState({ attributeData: attributeData });
    this.props.attributeData(attributeData, this.state.indexKey);
    this.clearAttribute();
  };

  updateAttriute = e => {
    e.preventDefault(); 
    let updateDataDateArray = this.state.updateDataDateArray;
    let attrData = {
      name: attributeName,
      dataValue:
        this.state.type == "menu" ? updateDataValueArray : updateDataDateArray,
      type: this.state.type
    };

    let newAttribute = this.state.attributeData;
    newAttribute[this.state.editIndex] = attrData;
    this.setState({ attributeData: newAttribute });
    this.props.attributeData(newAttribute, this.state.indexKey);
    this.clearAttribute();
  };

  handleAttributeName = e => {
    attributeName = e.target.value;
  };
  setAttributeValue = e => {
    attributeValue = e.target.value;
  };

  addAttributeValue = e => {
    e.preventDefault();
    if (this.state.attributeValueArray) {
      attributeValueArray = this.state.attributeValueArray;
    }
    attributeValueArray.push(attributeValue);
    this.setState({ attributeValueArray: attributeValueArray });
    updateDataValueArray = attributeValueArray;
    attributeValue = "";
  };

  addAttributeDate = e => {
    e.preventDefault();
    attributeDateArray = this.state.attributeDateArray ? this.state.attributeDateArray : [];
    let constData = {
      startDateTime: this.state.startDateTime,
      endDateTime: this.state.endDateTime
    };
    attributeDateArray.push(constData);
    this.setState({ attributeDateArray: attributeDateArray });
    this.setState({ startDateTime: "", endDateTime: "" });
  };

  removeAttributeValue = e => {
    e.preventDefault();
    attributeValueArray = this.state.attributeValueArray;
    attributeValueArray.splice(
      e.target.attributes.getNamedItem("data-key").value,
      1
    );
    this.setState({ attributeValueArray: (attributeValueArray) ? attributeValueArray : [] });
    updateDataValueArray = (attributeValueArray) ? attributeValueArray : [];
  };

  removeAttributeDate = e => {
    let updateDataDateArray;
    e.preventDefault();
    attributeDateArray = this.state.attributeDateArray;
    attributeDateArray.splice(
      e.target.attributes.getNamedItem("data-key").value,
      1
    );
    this.setState({ attributeDateArray: attributeDateArray });
    updateDataDateArray = attributeDateArray;
    this.setState({updateDataDateArray: updateDataDateArray})
  };

  removeattributeData = e => {
    e.preventDefault();
    let attributeData = this.state.attributeData;
    attributeData.splice(e.target.attributes.getNamedItem("data-key").value, 1);
    this.setState({ attributeData: attributeData });
  };

  editattributeData = e => {
    let getAttributeData = this.state.attributeData;
    let editData =
      getAttributeData[e.target.attributes.getNamedItem("data-key").value];
    attributeName = editData.name;
    if (editData.type == "menu") {
      updateDataValueArray = editData.dataValue;
      this.setState({
        attributeValueArray: editData.dataValue,
        attributeStatus: true,
        type: editData.type,
        edittype: editData.type,
        updateData: true,
        chooseType: true,
        editIndex: e.target.attributes.getNamedItem("data-key").value,
      });
    } else {
      let setDate;
      if(!isEmpty(editData.dataValue)){
        setDate = editData.dataValue.map((idx, val) =>{
          return {
            startDateTime: new Date(moment(idx.startDateTime).format('YYYY-MM-DD HH:mm')),
            endDateTime: new Date(moment(idx.endDateTime).format('YYYY-MM-DD HH:mm')),
          };
        });
      }
      this.setState({
        attributeDateArray: setDate,
        updateDataDateArray:setDate,
        attributeStatus: true,
        type: editData.type,
        edittype: editData.type,
        updateData: true,
        editIndex: e.target.attributes.getNamedItem("data-key").value,
        chooseType: false,
      });
    }
  };

  updateAttributeValue = e => {
    let index = e.target.attributes.getNamedItem("data-key").value;
    updateDataValueArray = this.state.attributeValueArray;
    updateDataValueArray[index] = e.target.value;
  };

  createMatrix(newArray) {
    newMatrix = newArray;
  }

  skuUpdateMatrix = e => {
    let index = e.target.attributes.getNamedItem("data-key").value;
    
    if (!Array.isArray(skuCode[this.props.indexKey])) {
      skuCode[this.props.indexKey] = [];
    }
    if (!Array.isArray(skuCode[this.props.indexKey][index])) {
      skuCode[this.props.indexKey][index] = [];
    }
    skuCode[this.props.indexKey][index] = e.target.value;
  };

  qtyUpdateMatrix = e => {
    let index = e.target.attributes.getNamedItem("data-key").value;
    
    if (!Array.isArray(quantity[this.props.indexKey])) {
      quantity[this.props.indexKey] = [];
    }

    if (!Array.isArray(quantity[this.props.indexKey][index])) {
      quantity[this.props.indexKey][index] = [];
    }
    quantity[this.props.indexKey][index] = e.target.value;
  };

  saveMatrix = e => {
    e.preventDefault();
    let inc = 0;
    let generatedMatrix = [];
    let val = '';
    this.setState({ quantity: quantity });
    this.setState({ skuCode: skuCode }); 
    createdMatrix = [];
    for (let i = 1; i < newMatrix.length; i++) {
      if (!Array.isArray(createdMatrix[inc])) {
        createdMatrix[inc] = [];
        createdMatrix[inc]['value'] = '';
      }
      val ='';
      for (let r = 0; r < newMatrix[i].length; r++) { 
        val = val + (val ? ', ' : '') + title[r] + ' :: ' + newMatrix[i][r];
        createdMatrix[inc]['value'] = val; // [title[r]] + ' :: ' + newMatrix[i][r]; 
      } 
      createdMatrix[inc]["quantity"] = (quantity && quantity[this.props.indexKey] && quantity[this.props.indexKey][i]) ? quantity[this.props.indexKey][i] : "";
      createdMatrix[inc]["skuCode"] = (skuCode && skuCode[this.props.indexKey] && skuCode[this.props.indexKey][i]) ? skuCode[this.props.indexKey][i] : "";

      inc++;
    }
    for (let k = 0; k < createdMatrix.length; k++) {
      generatedMatrix.push(Object.assign({}, createdMatrix[k]));
    } 
    this.props.matrixData(generatedMatrix, this.state.indexKey); 
    alert('Attributes updated successfully!');
    this.setState({ lgShow: false });
  };

  render() { 
    let newquantity = this.state.quantity;
    let newskuCode = this.state.skuCode;
    
    let lgClose = () => this.setState({ lgShow: false });
    let data, value = [], date;
    // Matrix Code Start
    let totalValue = [],
      newArray = [],
      matrix = [],
      totalCol;
       title = [];
    let dates;
    if (!isEmpty(this.state.attributeData) && this.state.attributeData !== "null" && this.state.attributeData !== '') {
      this.state.attributeData.map((attrData, index) => {
        title.push(attrData.name);
        totalValue.push(attrData.dataValue.length);
        if(attrData.type=='menu'){
          matrix.push(attrData.dataValue);
        } else {
          dates = attrData.dataValue.map((val, idx) =>{
            return moment(val.startDateTime).format("YYYY-MM-DD HH:mm") + ' to ' + moment(val.endDateTime).format("YYYY-MM-DD HH:mm")
          })
          matrix.push(dates);
        }
      });
    }

  
    if (!isEmpty(this.state.attributeValueArray) && this.state.attributeValueArray.length > 0 ) {
      value = this.state.attributeValueArray.map((data, index) => (
        <Row className="multi-addAttribute">
          <FormGroup key={index}>
            <Col md={3} sm={6}>&nbsp;</Col>
            <Col md={4} sm={6}>
              <Row>
                <Col sm={8}>
                  <FormControl
                    type="text"
                    name="value"
                    data-key={index}
                    defaultValue={data}
                    onChange={this.updateAttributeValue}
                    placeholder="Attribute Value"
                  />
                </Col>
                <Col sm={4}>
                  <a
                    className="btn-danger bt-remove text-danger"
                    data-key={index}
                    onClick={this.removeAttributeValue}
                  >
                  Remove
                  </a>
                </Col>
              </Row>
              
            </Col>
            
          </FormGroup>
        </Row>
      ));
    }else{
      value = [];
    }

    
    if (!isEmpty(matrix)) {
      totalCol = totalValue.reduce((a, b) => a * b);
      if(totalCol > 0) {
        let j = 0;
        for (let i = 0; i < matrix.length; i++) {
          if (i == j) {
            let loop = totalCol / matrix[i].length;
            let l = 0;
            while (l <= totalCol) {
              for (let k = 0; k < matrix[i].length; k++) {
                if (i == 0) {
                  for (let r = 0; r < loop; r++) {
                    l++;
                    if (!(l > totalCol)) {
                      if (!Array.isArray(newArray[l])) {
                        newArray[l] = [];
                      }
                      newArray[l].push(matrix[i][k]);
                    }
                  }
                } else {
                  l++;
                  if (!(l > totalCol)) {
                    if (!Array.isArray(newArray[l])) {
                      newArray[l] = [];
                    }
                    newArray[l].push(matrix[i][k]);
                  }
                }
              }
            }
          }
          j++;
        }

        this.createMatrix(newArray);
      }
    }

    // Matrix Code End
    if (!isEmpty(this.state.attributeData) && this.state.attributeData !== "null" && this.state.attributeData !== '') {
      data = this.state.attributeData.map((attrData, index) => (
        <FormGroup key={index}>
        <Row key={index}> 
          <Col sm={4}>
            <ControlLabel> Attibute Name: </ControlLabel> {attrData.name}
          </Col>
            <Col sm={6}>
              <ControlLabel> Attibute Value: </ControlLabel> 
              <FormControl componentClass="select" placeholder="select" style={{ width: 200,display: 'inline' }}>                
                {!isEmpty(attrData.dataValue) &&
                  attrData.dataValue.map((value, index) => (
                    <option
                      value={
                        attrData.type == "menu"
                          ? value
                          : moment(value.startDateTime).format(
                              "YYYY-MM-DD HH:mm"
                            ) +
                            " to " +
                            moment(value.endDateTime).format("YYYY-MM-DD HH:mm")
                      }
                    >
                      {attrData.type == "menu"
                        ? value
                        : moment(value.startDateTime).format(
                            "YYYY-MM-DD HH:mm"
                          ) +
                          " to " +
                          moment(value.endDateTime).format("YYYY-MM-DD HH:mm")}
                    </option>
                  ))}
              </FormControl>
            </Col>
            <Col sm={1}>
              <a
                className="text-danger"
                data-key={index}
                onClick={this.editattributeData}
              >
                Edit
              </a>
            </Col>
            <Col sm={1}>
              <a
                className="text-danger"
                data-key={index}
                onClick={this.removeattributeData}
              >
                Remove
              </a>
            </Col>
        </Row>
        </FormGroup>
      ));
    }
    if (!isEmpty(this.state.attributeDateArray)) {
      date = this.state.attributeDateArray.map((data, index) => (
        <FormGroup key={index}>
        <Row>
        
        <Col sm={12} md={3}  key={index}> </Col>
          
          <Col sm={12} md={3}>
            <DateTimePicker
              onChange={this.startDateTime}
              value={data.startDateTime}
            />
          </Col>
          <Col sm={12} md={3}>
            <DateTimePicker
              onChange={this.endDateTime}
              value={data.endDateTime}
            />
          </Col>
          <Col sm={12} md={3}>
            <a
              className="text-danger"
              data-key={index}
              onClick={this.removeAttributeDate}
            >
              Remove 
            </a>
          </Col>
          
        
        </Row>
        </FormGroup>
      ));
    }
    
    return (
      <Row key={Math.random()} className="add-attribute">
        <Col sm={12} md={9}>
        {!isEmpty(this.state.attributeData)?
        <h4>Attributes</h4>
          :''}
          {data}
        </Col>
     
        {this.state.attributeStatus == true ? (
          <Col sm={12} md={12}>
          <Row>
            <FormGroup>
              <Col sm={6} md={3}>
               <ControlLabel>Name of attribute:    </ControlLabel>             
              </Col>
              <Col sm={6} md={4}>
                <FormControl
                  type="text"
                  name="attribute"
                  defaultValue={attributeName}
                  placeholder="Attribute Name"
                  onChange={this.handleAttributeName}
                />
                 <span>(ie: Size, Color, etc)</span>
              </Col>
            </FormGroup>
             </Row>
             <Row>
            <FormGroup>
              <Col sm={6} md={3}>  <ControlLabel>Choose Type:  </ControlLabel></Col>
              <Col sm={6} md={4}>
               <Row>
               <Col sm={6}>
                <FormGroup>
                  <Radio
                    name="radioGroup"
                    defaultChecked={this.state.type == "menu" ? true : ""}
                    disabled={
                      this.state.edittype == "menu" || this.state.edittype == ""
                        ? false
                        : true
                    }
                    value="menu"
                    onClick={this.handleType}
                  >
                    Selection Menu
                  </Radio>
                </FormGroup>
                 </Col>
                  <Col sm={6}>
                  <FormGroup>
                  <Radio
                    name="radioGroup"
                    defaultChecked={this.state.type == "date" ? true : ""}
                    disabled={
                      this.state.edittype == "date" || this.state.edittype == ""
                        ? false
                        : true
                    }
                    value="date"
                    onClick={this.handleType}
                  >
                    Date & Time
                  </Radio>
                </FormGroup>
                   </Col>
              </Row>
              </Col>
            </FormGroup>

              </Row>
            {this.state.chooseType == true ? (
              <div>
              <Row>
                <FormGroup>
                  <Col sm={6} md={3}>  <ControlLabel>Value:  </ControlLabel></Col>

                  <Col sm={6} md={4}>
                   <Row>
                       <Col sm={8}>
                      <FormControl
                        type="text"
                        name="value"
                        onChange={this.setAttributeValue}
                        placeholder="Attribute Value"
                      />
                     </Col>
                        <Col sm={4}>
                         <a
                      className="btn-success btn-addattr"
                      onClick={this.addAttributeValue}
                    >
                      Add
                    </a>
                        </Col>
                    </Row>
                  </Col>                  
                </FormGroup>
                
              </Row>
              {value}
              </div>
            ) : (
              <div>
                <FormGroup>
                  <Row>
                    <Col sm={6} md={3}> 
                      <ControlLabel> Value: </ControlLabel> 
                    </Col>
                    <Col sm={6} md={3}>
                      <DateTimePicker
                         className="str-date"
                        onChange={this.startDateTime}
                        value={this.state.startDateTime}
                      />
                    </Col>
                    <Col  sm={6} md={3}>
                      <DateTimePicker 
                        className="end-date"
                        onChange={this.endDateTime}
                        value={this.state.endDateTime}
                      />
                    </Col>
                    <Col sm={12} md={2}>
                      <a className="btn-success btn-addattr" onClick={this.addAttributeDate}>
                        Add
                      </a>
                    </Col>        
                  </Row>
                </FormGroup>
                {date}
              </div>
            )}
            <div className="btn-grp">
              <FormGroup>
                {this.state.updateData == false ? (
                  <Row>
                    <Col smOffset={3} sm={2}>
                      <Button
                        bsSize="small"
                        onClick={this.saveAttriute}
                        bsStyle="success"
                      >
                        Save
                      </Button>
                    </Col>
                    <Col sm={2}>
                      <Button
                        bsSize="small"
                        onClick={this.cancelAttriute}
                        bsStyle="default"
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col smOffset={3} sm={2}>
                      <Button
                        bsSize="small"
                        onClick={this.updateAttriute}
                        bsStyle="success"
                      >
                        Save
                      </Button>
                    </Col>
                      <Col sm={2}>
                      <Button
                        bsSize="small"
                        onClick={this.cancelAttriute}
                        bsStyle="default"
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                )}
              </FormGroup>          
            </div>
          </Col>
        ) : this.state.attributeFile == true ? (
          <Col sm={12} md={12}>
            <Row>
              <FormGroup>
                <Col sm={6} md={3}>
                  <ControlLabel>Upload Your File:    </ControlLabel>             
                </Col>
                <Col sm={6} md={4}> 
                  <FormControl type="file" id="exampleFormControlFile1" label="Example file input" />
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <div className="btn-grp">
                <FormGroup> 
                  <Col smOffset={3} sm={2}>
                    <Button
                      bsSize="small"
                      onClick={this.saveAttriute}
                      bsStyle="success"
                    >
                      Save
                    </Button>
                  </Col>
                  <Col sm={2}>
                    <Button
                      bsSize="small"
                      onClick={this.cancelAttriute}
                      bsStyle="default"
                    >
                      Cancel
                    </Button>
                  </Col> 
                </FormGroup>          
              </div>
            </Row>
          </Col>
        ) : (
          <Col sm={12} md={12}>
            <Button
              bsSize="small"
              onClick={this.AttributeStatus}
              bsStyle="success"
            >
              Add Attributes
            </Button>
            {!isEmpty(this.state.attributeData) ? (
              <Button
                bsSize="small"
                onClick={() => this.setState({ lgShow: true })}
                bsStyle="success"
              >
                Edit Quantity
              </Button>
            ) : ''}
            
          </Col>
        )}

        {this.state.lgShow == true}
        {
          <Modal
            show={this.state.lgShow}
            onHide={lgClose}
            bsSize="large"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">Manage Quantity</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table striped bordered condensed hover>
                <thead>
                  <tr>
                    {(this.state.attributeData && this.state.attributeData !== "null" && this.state.attributeData !== '') &&
                      this.state.attributeData.map((data, index) => (
                        <th>{data.name}</th>
                      ))}
                    <th>SKU Code</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(newArray) &&
                    newArray.map((data, index) => (
                      <tr>
                        {data.map((dataValue, idx) => (
                          <td>
                            {dataValue && dataValue.length > 0
                              ? dataValue
                              : dataValue ? moment(dataValue.startDateTime).format(
                                  "YYYY-MM-DD HH:mm"
                                ) +
                                " to " +
                                moment(dataValue.endDateTime).format(
                                  "YYYY-MM-DD HH:mm"
                                )
                                : ''
                            }
                          </td>
                        ))}
                        <td>
                          <FormControl
                            type="text"
                            onChange={this.skuUpdateMatrix}
                            name="skuCode"
                            data-key={index}
                            placeholder="SKU Code"
                            defaultValue={
                              (skuCode[this.props.indexKey] && skuCode[this.props.indexKey][index]) ? skuCode[this.props.indexKey][index] : ""
                            }
                          />
                        </td>
                        <td>
                          <FormControl
                            type="text"
                            onChange={this.qtyUpdateMatrix}
                            name="quantity"
                            defaultValue={
                              (quantity[this.props.indexKey] && quantity[this.props.indexKey][index]) ? quantity[this.props.indexKey][index] : ""
                            }
                            data-key={index}
                            placeholder="Quantity"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsSize="small"
                onClick={this.saveMatrix}
                bsStyle="success"
              >
                Save
              </Button>{" "}
              <Button onClick={() => this.setState({ lgShow: false })}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        }
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default Attributes;


// WEBPACK FOOTER //
// ./src/app/views/admin/product/Attributes.js